import React from 'react';
import "../css/cover.css"
import "../css/bootstrap.min.css"
import "../css/D-anim.css"
import Footer from './Footer';

class Uses extends React.Component{
  constructor(props) {
    super(props);
    this.state = {hidden : true};
  }

  componentDidMount() {
      setTimeout(() => {
          this.setState({hidden: false});
      }, this.props.waitBeforeShow);
  }
    render() {
        return(
          this.state.hidden ? <div id = "animation" class="shapeshifter play"></div> :
            <main role="main" class="inner cover">
                <h1>I use the following tools for designing my projects</h1>
                <h3>This page to be updated based on user's choice</h3>
                <a href="https://www.photoshop.com/en">Photoshop</a>
                <br/>
                <a href="https://www.adobe.com/in/products/illustrator.html">Illustrator</a>
                <br/>
                <a href="https://www.rhino3d.com/">Rhino 3D</a>
                <br/>
                <a href="https://www.autodesk.com/education/free-software/revit">Revit</a>
                <br/>
                <a href="https://www.autodesk.com/education/free-software/autocad">AutoCad</a>

            <Footer/>
          </main>
        );
    }
}
export default Uses;